import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import GiftModal from './GiftModal';

const GiftButton = ({ creatorId, creatorName, className = '' }) => {
  const [showModal, setShowModal] = useState(false);
  
  return (
    <>
      <Button
        onClick={() => setShowModal(true)}
        className={`bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-semibold ${className}`}
      >
        🎁 Enviar Presente
      </Button>
      
      <GiftModal 
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        creatorId={creatorId}
        creatorName={creatorName}
      />
    </>
  );
};

export default GiftButton;
